import { createApp } from 'vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import App from './App.vue'
import router from './router'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(faUserSecret)

const firebaseConfig = {
  apiKey: "AIzaSyBTfg597vEIgfVaao1S0SP0Yg11xkCzTz4",
  authDomain: "nopainnodsa.firebaseapp.com",
  projectId: "nopainnodsa",
  storageBucket: "nopainnodsa.firebasestorage.app",
  messagingSenderId: "150724009898",
  appId: "1:150724009898:web:7c7d7c2167c6f1b11dd5d3"
};

firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged(user => {
  if(!app) {
    console.log(user?.email.replace(user?.email, 'Hello there!'));
    
    app = createApp(App)
            .component('font-awesome-icon', FontAwesomeIcon)
            .use(router)
            .mount('#app');
  }
});